export const SERVICES = [
  {
    id: "mini",
    name: "Mini Support Session",
    duration: "30 Minutes",
    price: "$35",
    calendly: "https://calendly.com/camili_eyes/30min",
    blurb:
      "A quick reset, talk-through, or emotional support moment when you just need someone grounded and present.",
    bestFor: "When you need a brief pause and a steady ear.",
    benefits: [
      "Judgment-free conversation",
      "Grounded, present support",
      "A gentle reset in your day",
    ],
  },
  {
    id: "standard",
    name: "Standard Support Session",
    duration: "60 Minutes",
    price: "$65",
    featured: true,
    calendly: "https://calendly.com/camili_eyes/60-minute-standsrd-session",
    blurb:
      "Time to talk, process, and feel supported through whatever you're navigating — errands, conversations, or emotional clarity.",
    bestFor: "When you want unhurried time to think things through.",
    benefits: [
      "Real conversation and reflection",
      "Supportive companionship during errands, outings, or life transitions",
      "Space to find clarity",
    ],
  },
  {
    id: "extended",
    name: "Extended Support Experience",
    duration: "2 Hours",
    price: "$120",
    calendly: "https://calendly.com/camili_eyes/120-minute-extended-session",
    blurb:
      "A deeper, more relaxed experience — whether that's running errands together, getting out of the house, or having uninterrupted support.",
    bestFor: "When you'd like a slower, fuller day with steady company.",
    benefits: [
      "Extended, unhurried presence",
      "Errands, outings, or quiet company",
      "Time to settle and feel supported",
    ],
  },
];
